export default __webpack_public_path__ + "c0d5494cf120738424880127a8b7b456.svg";